/**
 * t402u: what a failed sign-in says. One message for every account problem (wrong password, no such user, unconfirmed,
 * disabled, wrong instance…), so the shared sign-in can't be used to find out who has an account. Only "you're offline"
 * and "slow down" differ, since they say nothing about the account.
 */
export const SIGN_IN_FAILED = 'Email or password is incorrect';
export const TOO_MANY = 'Too many attempts. Wait a minute and try again.';

export function signInErrorMessage(e: unknown, offlineMessage: string): string {
  const err = (e ?? {}) as { status?: number; name?: string; message?: string };
  const msg = typeof err.message === 'string' ? err.message : '';
  if (err.status === 429 || /rate limit|too many/i.test(msg)) return TOO_MANY;
  const offline = (typeof navigator !== 'undefined' && navigator.onLine === false)
    || err.name === 'AuthRetryableFetchError' || /failed to fetch|network ?error|network request failed|load failed/i.test(msg);
  return offline ? offlineMessage : SIGN_IN_FAILED;
}

/**
 * t402u: a failed sign-in (or reset request) answers no sooner than this after submit, so how long the server took
 * (a known account is checked against its password hash, an unknown one isn't) doesn't show.
 */
export const MIN_FAILURE_MS = 1200;
export async function padUntil(startedAt: number, ms = MIN_FAILURE_MS, now: () => number = Date.now, sleep = (t: number) => new Promise<void>(r => setTimeout(r, t))) {
  const left = startedAt + ms - now();
  if (left > 0) await sleep(left);
}
